import React from 'react';
import styles from './PartnershipBlockMobile.scss';
import Dropdown from 'react-dropdown';

export default function PartnershipBlock() {
  const value = '1 млн Ք';
  return (
    <div className={styles.partnershipBlockMobile}>
      <h3 className={styles.header}>Хотите стать партнером?</h3>
      <div className={styles.incomeBlock, 'dropdown'}>
        <div>Оборот в месяц</div>
        <div style={{textAlign: 'right'}}>
          <Dropdown
            options={[value]}
            value={value}
            placeholder={value} />
        </div>
        <div>Прибыль</div>
        <div style={{textAlign: 'right'}}>500 000 т. <span className="price">&#8381;</span></div>
      </div>
      <button className={styles.registerBtn}>Зарегистрироваться</button>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/PartnershipBlock/PartnershipBlockMobile.jsx
 **/